import styled from "styled-components";
import { breakpoints } from "styles";

export const NpsParentFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
`;

export const CocoReadingImageContainer = styled.div`
  height: 144px;
  width: 144px;
`;

export const ParentFormHeading = styled.h1`
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral["900"]};
  margin: 32px 0 0 0;
  width: 320px;
  line-height: 28px;
  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    width: 460px;
    line-height: 40px;
  }
`;

export const ParentFormSubheading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["900"]};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  width: 320px;
  text-align: center;
  margin: 24px 0 24px 0;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
    width: 425px;
  }
`;

export const ParentMobileInputContainer = styled.div`
  margin: 0 0 24px 0;
  width: 320px;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
    width: 425px;
  }
`;

export const StyledButtonContainer = styled.div`
  width: 100%;

  @media ${breakpoints.laptop} {
    margin: 0 0 24px 0;
    width: 250px;
  }
`;

export const SeeYouLaterCTA = styled.button`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  background: none;
  border: none;
  font-weight: bold;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  cursor: pointer;
  margin-top: 20px;

  @media ${breakpoints.laptop} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    margin-top: 0;
  }
`;
